Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    optionListOptionMobileSpacingInsetVertical: 16,
    optionListOptionMobileSpacingInsetHorizontal: 16,
    optionListOptionSpacingInsetVertical: 8,
    optionListOptionSpacingInsetHorizontal: 12,
    optionListOptionForegroundColorDefault: tokens.themeInkDefault,
    optionListOptionForegroundColorDisabledDefault: tokens.themeInkDisabled,
    optionListOptionForegroundColorDisabledFocus: tokens.themeActionPrimaryDisabled,
    optionListOptionForegroundColorPreselected: tokens.themeInkInverse,
    optionListOptionForegroundColorPressed: tokens.themeInkInverse,
    optionListOptionForegroundColorSelected: tokens.themeInkInverse,
    optionListOptionBackgroundColorDefault: tokens.themePageDefault,
    optionListOptionBackgroundColorDisabledDefault: tokens.themePageDefault,
    optionListOptionBackgroundColorDisabledFocus: tokens.themeActionPrimaryDisabledSubdued,
    optionListOptionBackgroundColorPreselected: tokens.themeActionPrimaryHover,
    optionListOptionBackgroundColorPressed: tokens.themeActionPrimaryPressed,
    optionListOptionBackgroundColorSelected: tokens.themeActionPrimaryDefault,
    optionListOptionIndicatorColorDefault: "rgba(0, 0, 0, 0)",
    optionListOptionIndicatorColorDisabled: tokens.themeInkDisabled,
    optionListOptionIndicatorColorPreselected: tokens.themeDecorativePaletteDefault,
    optionListOptionIndicatorColorPressed: tokens.themeInkInverse,
    optionListOptionIndicatorColorSelected: tokens.themeInkInverse,
    optionListOptionMotionDuration: "100ms",
    optionListOptionMotionFunction: "ease",
    optionListOptionLineHeight: "24px",
    optionListGroupHeaderSpacingInsetVertical: 8,
    optionListGroupHeaderSpacingInsetHorizontal: 12,
    optionListGroupHeaderForegroundColorDefault: tokens.themeInkSubdued,
    optionListGroupHeaderForegroundColorDisabled: tokens.themeInkDisabled,
    optionListGroupHeaderBackgroundColorDefault: tokens.themePageDefault,
    optionListGroupHeaderBackgroundColorDisabled: tokens.themePageDefault,
    optionListGroupHeaderFontWeight: 600,
    optionListGroupBorderColor: tokens.themeBorderDefault,
    optionListGroupBorderWidth: 1
  }
};